import { Model } from "./model";
import { User } from "./user.model";
import { Shop } from "./shop.model";

export class OrderDetail extends Model {
    id: number;
    reference: string;
    shop_name: string;
    delivery_name: string;
    delivery_address: string;
    number: string;
    comments?: string;
    status: string;
    status_value?: number;
    notification: boolean;
    notification_key?: string;
    owner_id: string;
    owner: User;
    manager_id?: string;
    manager?: User;
    shop_id: Shop;
    created: string;
    modified?: string;
    orderPosmSubitem: Array<any>;
}


// WEBPACK FOOTER //
// ./src/models/order-detail.model.ts